import axios from 'axios';
import { format } from 'date-fns';
import {
    MDBAlert,
    MDBBadge,
    MDBBtn,
    MDBCardTitle, MDBAnimation,
    MDBCheckbox,
    MDBCol,
    MDBContainer,
    MDBDatepicker,
    MDBIcon,
    MDBInput,
    MDBListGroup, MDBListGroupItem,
    MDBRadio,
    MDBRow,
    MDBSelect,
    MDBSpinner,
    MDBStepper,
    MDBStepperStep,
    MDBTable, MDBTableBody,MDBCardBody,
    MDBTextArea,
    MDBValidationItem
} from 'mdb-react-ui-kit';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';

import { useNavigate, useParams, Link } from 'react-router-dom';
import AddressFormModal from '../address/AddressFormModal';
import EmailFormModal from '../email/EmailFormModal';
import UserProfile from '../login/profile/UserProfile';
import UserProfileModal from '../login/profile/UserProfileModal';
import PhoneFormModal from '../phones/PhoneFormModal';
import ThankyouModal from './ThankyouModal';
import {  PasswordAlertCard,fetchMainPageData } from '../utils/Common';
import UserMessagesModal from '../messages/UserMessagesModal';
import { NavbarContext } from '../context/NavProvider';
import { CartContext } from '../context/CartProvider';
import {UserProfileContext} from "../context/UserProfileProvider";
import { GeographyContext } from '../context/GeographyProvider';
import { MiscContext } from '../context/MiscProvider';
export default function Checkout() { 
    
const { pricingCategoryId } = useParams();
const [isLoading, setIsLoading] = useState(false);
const {stateOptions = [], setStateOptions, country,location, ipAddress} = useContext(GeographyContext)
const { cart = [], setCart, setCartCount, cartId, setCartId, setDeliveryDate, deliveryDate, setAddedEntities, setOrders, orders = [] } = useContext(CartContext);
const { setIsPricing, isPricing,pageData,setPageData,setBusiness } = useContext(NavbarContext);
const { tokenLoaded, addresses = [], phones = [], emails = [], userProfile, setUid } = useContext(UserProfileContext);
const [isUser, setIsUser] = useState(false);
const [isAddress, setIsAddress] = useState(false);
const [isEmail, setIsEmail] = useState(false);
const [isPhone, setIsPhone] = useState(false);
const [additionalInfo, setAdditionalInfo] = useState('');
const [createAccount, setCreateAccount] = useState(true);
const [saveCreditCard, setSaveCreditCard] = useState(true);
const [firstName, setFirstName] = useState("");
const [lastName, setLastName] = useState("");
const [password, setPassword] = useState("");
const [confirmPassword, setConfirmPassword] = useState("");

const handleIsUserProfileModalOpenToggle = () => {
  setIsUser(!isUser);
  resetStepper();
};
const [type, setType] = useState('Both');
const [postalCode, setPostalCode] = useState("");
const [stateOrProvince, setStateOrProvince] = useState("");
const [street, setStreet] = useState("");
const [locality, setLocality] = useState("");
const [newAddresses, setNewAddresses] = useState([]);
const [paymentType, setPaymentType] = useState('Credit Card'); // For radio buttons (Credit Card or Debit Card)
const [nameOnCard, setNameOnCard] = useState(''); // For Name on the card
const [cardNumber, setCardNumber] = useState(''); // For Credit Card Number
const [expirationDate, setExpirationDate] = useState(''); // For Expiry Date
const [cardCode, setCardCode] = useState(''); // For CVV
const navigate = useNavigate();
const handleIsAddressModalOpenToggle = () => { setIsAddress(!isAddress) };
const handleIsEmailModalOpenToggle = () => { setIsEmail(!isEmail) };
const handleIsPhoneModalOpenToggle = () => { setIsPhone(!isPhone) };
const baseUrl = process.env.REACT_APP_INVENTORY_URL;
const [activeStep, setActiveStep] = useState(tokenLoaded ? 3 : 1); // set your initial step here
const [showAlert, setShowAlert] = useState(false);
const [alertMessage, setAlertMessage] = useState('');
const [alertColor, setAlertColor] = useState('');
const toggleThankyouModal = () => setThankyouModal(!thankyouModal);
const [thankyouModal, setThankyouModal] = useState(false);
const addNewAddress = () => {
  const newAddress = { type: 'Shipping', firstName: '', lastName: '', street: '', locality: '', postalCode: '', stateOrProvince: '', countryName: country };
  setNewAddresses([...newAddresses, newAddress]);
};
const [formattedNextWeek ,setFormattedNextWeek] = useState('');
const [nextWeek, setNextWeek] = useState("");

const [phone, setPhone] = useState("");
const [email, setEmail] = useState("");
useEffect(() => {
  if (!deliveryDate || typeof deliveryDate !== 'string' || deliveryDate.trim() === '') {
    const nextWeekDate = new Date();
    nextWeekDate.setDate(nextWeekDate.getDate() + 9);
    setNextWeek(nextWeekDate);
    const formattedDate = format(nextWeekDate, 'dd, eeee, LLLL, yyyy');
    setFormattedNextWeek(formattedDate);
    setDeliveryDate(formattedDate);
  }
}, [deliveryDate, setDeliveryDate]);

    const removeAddress = (indexToRemove) => {
        setType('Both');
        const updatedAddresses = newAddresses.filter((_, index) => index !== indexToRemove);
        setNewAddresses(updatedAddresses);
    };


    const updateField = (index, field, value) => {
        const updatedAddresses = [...newAddresses];
        updatedAddresses[index][field] = value;
        setNewAddresses(updatedAddresses);
    };
    useEffect(() => {
      if (!pageData) {
        fetchMainPageData(setPageData,setIsPricing,pageData,setBusiness);
        
      }
    }, []);
    

    useEffect(() => {
        setIsPricing(window.location.host.includes("expenses") || window.location.host.includes("x-trk"));
        if (!tokenLoaded) {
            if (orders?.[0]?.addresses?.Shipping) {
                const shippingAddress = orders?.[0]?.addresses?.Shipping;
                setNewAddresses(prevAddresses => [...prevAddresses, shippingAddress]);
            }
            if (orders?.[0]?.addresses?.Billing) {
                const billing = orders[0]?.addresses?.Billing;
                setType(billing.type);
                setStreet(billing.street);
                setLocality(billing.locality);
                setPostalCode(billing.postalCode);
                setStateOrProvince(billing.stateOrProvince);
                setFirstName(billing.firstName);
                setLastName(billing.lastName);

            }
            if (orders?.[0]?.creditCard) {
                const creditCard = orders[0]?.creditCard;
                setPaymentType(creditCard.paymentType);
                setNameOnCard(creditCard.nameOnCard);
                setCardNumber(creditCard.cardNumber);

            }
            if(orders?.[0]?.email){
                setEmail(orders?.[0]?.email);
                }
                if(orders?.[0]?.phone){
                setPhone(orders?.[0]?.phone);
            }
        }
    }, [orders]);
    useEffect(() => {
        if (stateOptions?.length === 0)
            axios.get(`${baseUrl}/countries/name/US/stateCodes`)
                .then(response => {
                    const stateData = response.data?.map(state => ({
                        text: `${state.name} (${state.code})`,
                        value: state.code,
                    }));
                    setStateOptions(stateData);
                })
                .catch(error => {
                    console.error('There was an error fetching the state codes:', error);
                });
    }, [baseUrl, setStateOptions, stateOptions?.length]);


    useEffect(() => {
        if (emails?.length > 0) {
            const primaryEmail = emails.find(email => email.type === "primary")?.value || emails[0]?.value;
            setEmail(primaryEmail);
        }
        if (phones?.length > 0) {
            const primaryPhone = phones.find(phone => phone.type === "office")?.number || phones[0]?.number;
            setPhone(primaryPhone);
        }
        if (addresses?.length > 0) {
            const primaryAddress = addresses.find(address => address.addressPurposes.includes("Billing")) || addresses[0];
            setFirstName(primaryAddress.firstName);
            setLastName(primaryAddress.lastName);
            setStreet(primaryAddress.street);
            setLocality(primaryAddress.locality);
            setPostalCode(primaryAddress.postalCode);
            setStateOrProvince(primaryAddress.stateOrProvince);
            setType(primaryAddress.type);
        }
    }, [emails, phones, addresses]);
    

    function capitalizeFirstLetterOfEachWord(str) {
        return str?.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1);
        });
    }
    const resetStepper = () => {
        setActiveStep(2);
    };

    let billingAddress = null;
    let shippingAddress = null;

    if (Array.isArray(addresses)) {
        billingAddress = addresses?.find(address => address?.addressPurposes?.includes("Billing"));
        shippingAddress = addresses?.find(address => address?.addressPurposes?.includes("Shipping"));

        if (billingAddress && !shippingAddress) {
            shippingAddress = billingAddress;
        }

        if (shippingAddress && !billingAddress) {
            billingAddress = shippingAddress;
        }

        if (!billingAddress && !shippingAddress) {
            billingAddress = addresses[0];
            shippingAddress = addresses[0];
        }
    }



    const concatenatedBillingAddress = `${capitalizeFirstLetterOfEachWord(billingAddress?.street)}\n ${capitalizeFirstLetterOfEachWord(billingAddress?.locality)}\n ${capitalizeFirstLetterOfEachWord(billingAddress?.stateOrProvince)} ${capitalizeFirstLetterOfEachWord(billingAddress?.postalCode)}\n ${capitalizeFirstLetterOfEachWord(billingAddress?.countryName)}`;


    const concatenatedShippingAddress = `${capitalizeFirstLetterOfEachWord(shippingAddress?.street)}\n ${capitalizeFirstLetterOfEachWord(shippingAddress?.locality)}\n ${capitalizeFirstLetterOfEachWord(shippingAddress?.stateOrProvince)} ${capitalizeFirstLetterOfEachWord(shippingAddress?.postalCode)}\n ${capitalizeFirstLetterOfEachWord(shippingAddress?.countryName)}`;

    // If the same address is used for both billing and shipping, you can make that clear
    let isSameAddressForBoth = false;
    if (billingAddress?.id === shippingAddress?.id) {
        isSameAddressForBoth = true;
    }
    const primaryEmail = Array.isArray(emails)
        ? (emails?.find(email => email.type === "primary")?.value || emails[0]?.value)
        : undefined;

    const primaryPhone = Array.isArray(phones)
        ? (phones.find(phone => phone.type === "primary")?.number || phones[0]?.number)
        : undefined;


    const prevRef = useRef(null);
    const nextRef = useRef(null);
    function getCategoryGroups() {
        return cart?.entities?.reduce((groups, item) => {
            if (item.imageIds && item.imageIds.length > 0) {
                item.thumbnails = [item.imageIds[0]];  // Assuming that you meant to set thumbnails to the first image ID
            }
            if (item.categoryIdToName) {
                Object.entries(item.categoryIdToName).forEach(([categoryId, categoryName]) => {
                    const categoryGroup = groups[categoryName] || [];
                    categoryGroup.push(item);
                    groups[categoryName] = categoryGroup;
                });
            }
            return groups;
        }, {});
    }
    const removeCartItem = async (item) => {
        setActiveStep(1);
        try {

            const id = cartId;
            let url = item ? (tokenLoaded ? `${baseUrl}/cart/${id}/entity/${item.id}` : `${baseUrl}/cart/anonymous/${id}/entity/${item.id}`) : `${baseUrl}/cart/${cartId}`;

            url = url + `?ipAddress=${ipAddress}`;
            const response = await axios.delete(url);

            if (response.status === 200) {



                if (response.data.entities) {
                    setCart(response.data);
                    setAddedEntities(response.data.entities);
                    setCartCount(response.data.entities.length);
                } else {
                    setAddedEntities([]);
                    setCartId(null);
                    setCartCount(0);
                    localStorage.removeItem('CART-ID');

                    navigate("/products");
                }


            }
        } catch (error) {
            if (error.response && error.response.status === 404) {
                // Handle 404 error
                setCartId(null);
                setCartCount(0);

                navigate("/home");
            } else {
                console.error("Error removing item", error);
                // Handle other errors
            }

        }
    };
    const [validationMsg, setValidationMsg] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);
    const validateNewAddress = (address) => {
        return address.type && address.street && address.locality && address.firstName && address.lastName &&
            address.postalCode && address.stateOrProvince;
    };

    const validateFields = useCallback(() => {

        if (!(firstName && lastName && type && street && locality && postalCode && stateOrProvince && country && email  && phone && password && confirmPassword)) {
            
            setValidationMsg('Please fill all the fields');
        } else if (!(paymentType && nameOnCard && cardNumber && expirationDate && cardCode)) {
            setValidationMsg('Go to Payment Section ');
        } else if (!(newAddresses.length === 0 || newAddresses.every(validateNewAddress))) {
            setValidationMsg('fill the address ');
        }
        if (
            firstName && lastName && type && street && locality && postalCode && stateOrProvince && country && email && phone && password && confirmPassword &&  paymentType && nameOnCard && cardNumber && expirationDate && cardCode &&
            (newAddresses.length === 0 || newAddresses.every(validateNewAddress))
        ) {
            setIsFormValid(true);
            setValidationMsg('');
            return true;
        }
        setIsFormValid(false);

        return true;
    }, [firstName, lastName, type, street, locality, postalCode, stateOrProvince, country, email, phone, password, confirmPassword, paymentType, nameOnCard, cardNumber, expirationDate, cardCode, newAddresses]);
    const validateFieldsWhenLoggedin = useCallback(() => {
        if (
            paymentType && nameOnCard && cardNumber && expirationDate && cardCode

        ) {
            setIsFormValid(true);

            return false;
        }
        setIsFormValid(false);
        setValidationMsg('Go to CreditCard ');
        return false;
    }, [paymentType, nameOnCard, cardNumber, expirationDate, cardCode]);





    const handleSubmit = async (event) => {

        if (!deliveryDate) {
            console.log("in if formattedNextWeek:", formattedNextWeek);
            setDeliveryDate &&  setDeliveryDate(formattedNextWeek);
        }

        if (event) event.preventDefault();
        const order = {
            ldapUser: { firstName, lastName, password, confirmPassword },
            addresses: {
                addressSet: [
                    {
                        firstName,
                        lastName,
                        street,
                        locality,
                        postalCode,
                        countryName: country,
                        stateOrProvince,
                        type,
                    }
                ]
            },
            isPricing: isPricing,
            deliveryDate: deliveryDate || formattedNextWeek,
            phones: { phoneSet: [{ number: phone, type: "primary" }] },
            emails: { emails: [{ value: email, type: "primary" }] },
            additionalInfo,
            createAccount,
            cartId,
            creditCard: { paymentType, nameOnCard, cardNumber, expirationDate, cardCode, saveCreditCard }

        };

        order.addresses.addressSet = [...order.addresses.addressSet, ...newAddresses];
        const missingFields = [];
        if (!tokenLoaded) {
            console.log("in token   deliveryDate:", deliveryDate);
            if (!order.addresses.addressSet[0]?.street || !order.addresses.addressSet[0]?.postalCode || !order.addresses.addressSet[0]?.countryName || !order.addresses.addressSet[0]?.stateOrProvince || !order.addresses.addressSet[0]?.type) {
                missingFields.push('address');
            }
            if (!order.phones.phoneSet[0].number) {
                missingFields.push('phone');
            }
            if (!order.emails.emails[0].value) {
                missingFields.push('email');
            }


            if (missingFields.length > 0) {
                // Alert if any of the fields are missing
                setAlertMessage(`Please fill in the missing ${missingFields.join(', ')} information.`);
                setAlertColor('danger');
                setShowAlert(true);
                setTimeout(() => setShowAlert(false), 5 * 10000);
                return; // Exit out of the function, don't proceed to API call onClick={addAddress}
            }
        }
        if (!order.deliveryDate) {
            missingFields.push('delivery date in cart before come to checkout');
        }
        if (!order.creditCard.paymentType || !order.creditCard.nameOnCard || !order.creditCard.cardNumber || !order.creditCard.expirationDate || !order.creditCard.cardCode) {
            missingFields.push('creditCard');
        }

        try {
            let latLngQuery = "";
            if (location) {
                latLngQuery = `?latitude=${location.latitude}&longitude=${location.longitude}`;
            } else {
                latLngQuery = `?ipAddress=${ipAddress}`;
            }

            let url = tokenLoaded ? `${baseUrl}/orders` : `${baseUrl}/orders/anonymous`;
            url = url + latLngQuery;
            setIsLoading(true);
            console.log('order', order);
            const response = await axios.post(url,
                order,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            );
            if (response.data) {
                console.log("Order Created:", response.data);
                setOrders(response.data);
                setUid(response.data?.[0]?.createdBy);
                setIsLoading(false);
             if(response.data?.[0]?.createdBy){
                navigate('/order-view/true'); 
             }else if(response.data?.[0]?.userMessages){
                navigate('/order-view/true'); 

             }
             
             else{ 
                isPricing ? navigate('/shop/pricing') :navigate('/products')
                setCartCount(0);
                setCart(null);
                setCartId(null);
                localStorage.removeItem('CART-ID');
                  }
            }
        } catch (error) {
            setIsLoading(false);
            console.error("There was an error creating the order", error);
            setAlertMessage(`Problem in creating your Order please reach us at support@opengrit.com`);
            setAlertColor('danger');
            setShowAlert(true);
isPricing ? navigate('/checkout/pricing') :  navigate('/checkout');

          
            setOrders([]);
            setTimeout(() => setShowAlert(false), 20 * 10000);
            return;
        }

    };

    useEffect(() => {
        tokenLoaded ? validateFieldsWhenLoggedin() : validateFields();
    }, [tokenLoaded, validateFields, validateFieldsWhenLoggedin]);





    return (
        isLoading ? <div className='d-flex m-5 justify-content-center' >
            <MDBSpinner style={{ width: '6rem', height: '6rem' }} color='warning'>

            </MDBSpinner>
        </div> :
            <MDBContainer className="mb-0 ,justify-content-center ">
{orders?.length > 0 &&<UserMessagesModal status={orders[0]?.status} messages={orders[0]?.userMessages || []} />}
                <ThankyouModal toggleThankyouModal={toggleThankyouModal} thankyouModal={thankyouModal} setThankyouModal={setThankyouModal} handleSubmit={handleSubmit} />
                <MDBAlert open={showAlert} className='mt-2'
                    color="secondary"
                    autohide
                    width={800}
                    delay={20000}
                    onClick={() => setShowAlert(false)}
                >
                   <MDBIcon fas icon="exclamation me-3" />  {alertMessage} <MDBBtn color='link' rippleColor='light' onClick={()=>setShowAlert(false)}>close</MDBBtn>
                </MDBAlert >
                <MDBRow className='justify-content-center align-items-center' >


                    <h2 className="display-7 fw-bold text-uppercase text-success mb-0 mt-2 " style={{ letterSpacing: "1px" }}>Checkout</h2>

                    <MDBCol>


                        <MDBRow className='rounded text-center mt-3 grainy-gradient-intro' style={{ backgroundColor: 'white', borderRadius: "12px" }}>

                            <MDBCol lg="8" className="mb-1">
                                {(isPricing || window.location.host.includes("expenses")) && <span className='justify-content-center align-items-center' style={{ minWidth: '10rem', textAlign: 'center' }}>
                                    <Link to='/' className='m-1 ' href='#'>
                                        <MDBIcon fas icon="hand-point-left" />  Go Back to Subscribe
                                    </Link> </span>}
                                <MDBRow className='mb-1 mt-0'>
                                    <MDBCol >

                                        <MDBBtn tag='a' color='none' className='m-1 me-4 ' style={{ color: '#dd4b39' }} ref={prevRef}> <MDBIcon fas icon='arrow-left' size='2x' /></MDBBtn>

                                        <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#dd4b39' }} ref={nextRef}> <MDBIcon fas icon='arrow-right' size='2x' /> </MDBBtn>


                                    </MDBCol>
                                    <MDBStepper externalNext={nextRef} externalPrev={prevRef} className="justify-content-center" defaultStep={activeStep} type='vertical'>
                                        <div className='rounded-5   text-dark ' >
                                            {tokenLoaded &&
                                                <MDBStepperStep headIcon=<MDBIcon fab icon="hornbill" /> headText='Billing' itemId={1} >

                                                    <MDBRow className='mb-4 '>
                                                        <MDBCol>
                                                            <MDBInput id='form6Example2' value={userProfile.firstName} label='First Name' disabled />
                                                        </MDBCol>

                                                        <MDBCol className='position-relative d-inline-block'>
                                                            <MDBInput id='form6Example2' value={userProfile.lastName} label='Last Name' disabled />
                                                        </MDBCol>
                                                    </MDBRow>
                                                    <MDBRow className='mt-1'>
                                                        {isSameAddressForBoth ? <MDBCol md="6" className="mb-2 position-relative d-inline-block">
                                                            <MDBTextArea wrapperClass='mb-2' rows={4} id='form6Example4' value={concatenatedBillingAddress} label='Address' disabled />
                                                        </MDBCol> : <>

                                                            <MDBCol md="6" className="mb-2 position-relative d-inline-block">
                                                                <MDBTextArea wrapperClass='mb-2' rows={4} id='form6Example4' value={concatenatedBillingAddress} label='Billing Address' disabled />
                                                            </MDBCol>
                                                            <MDBCol md="6" className="mb-2 position-relative d-inline-block">
                                                                <MDBTextArea wrapperClass='mb-2' rows={4} id='form6Example4' value={concatenatedShippingAddress} label='ShippingAddress' disabled />
                                                            </MDBCol>
                                                        </>}
                                                        <MDBCol md="6" className="mb-2">
                                                            <MDBInput wrapperClass='mb-4' type='email' value={primaryEmail} id='form6Example5' label='Email' disabled />
                                                            <MDBInput wrapperClass='mb-4' type='tel' value={primaryPhone} id='form6Example5' label='Phone' disabled />
                                                        </MDBCol>
                                                    </MDBRow>

                                                    {!pricingCategoryId && <MDBValidationItem invalid feedback='invalid'>
                                                        <MDBDatepicker format='dd, dddd, mmmm, yyyy'  defaultValue={deliveryDate || orders?.[0]?.deliveryDate || formattedNextWeek} disablePast onChange={(date) => { setDeliveryDate(date); validateFields(); }} inputToggle inputLabel='Select a delivery date' />

                                                    </MDBValidationItem>}

                                                    <MDBInput wrapperClass='mb-4 mt-4' textarea id='form6Example7' rows={4} label='Additional information' onChange={(e) => setAdditionalInfo(e.target.value)} />


                                                </MDBStepperStep >}

                                            <MDBStepperStep headIcon=<MDBIcon far icon="address-card" /> headText={tokenLoaded ? 'UpdateAddress' : "Billing Address"} itemId={tokenLoaded ? 2 : 1} >

                                                {tokenLoaded ? <UserProfile isCheckout={true} /> :


                                                    <MDBCardBody className='rounded-5 bg-light p-2 text-dark bg-opacity-0'>

                                                        <MDBRow className='mb-4'>
                                                            <p> Address </p>
                                                            <MDBCol>
                                                                <MDBInput  label='First name *' value={orders?.[0]?.addresses?.Billing?.firstName} id='formFirstName1' onChange={(e) => { setFirstName(e.target.value); validateFields(); }} />
                                                            </MDBCol>
                                                            <MDBCol>
                                                                <MDBInput label='Last name *' id='formLastName1' value={orders?.[0]?.addresses?.Billing?.lastName} onChange={(e) => { setLastName(e.target.value); validateFields(); }} />
                                                            </MDBCol>
                                                        </MDBRow>

                                                        <MDBSelect label='Billing and Shipping? *'
                                                            className='mb-4'
                                                            data={type === 'Billing' ? [
                                                                { text: 'Billing' },
                                                                { text: 'Both' },
                                                                { text: 'Shipping' }
                                                            ] : [
                                                                { text: 'Both' },
                                                                { text: 'Billing' },
                                                                { text: 'Shipping' }
                                                            ]}
                                                            defaultValue={type}
                                                            onValueChange={(selectedValue) => {
                                                                console.log("Changing type to: ", selectedValue.value);
                                                                setType(selectedValue.text)
                                                            }}
                                                        />
                                                        <MDBInput wrapperClass='mb-4' value={orders?.[0]?.addresses?.Billing?.street} id='form6Street4' label='Street *' onChange={(e) => { setStreet(e.target.value); validateFields(); }} />
                                                        <MDBInput wrapperClass='mb-4' value={orders?.[0]?.addresses?.Billing?.locality} id='form7Example5' label='City *' onChange={(e) => { setLocality(e.target.value); validateFields(); }} />
                                                        <MDBInput wrapperClass='mb-4' value={orders?.[0]?.addresses?.Billing?.postalCode} id='form6PostalCode6' label='Postcode *' onChange={(e) => { setPostalCode(e.target.value); validateFields(); }} />

                                                        <MDBSelect name='stateOrProvince'   label='State or Province *' id='stateOrProvinceSelect'  type='text'  search  preventFirstSelection className='mt-2 mb-4' data={stateOptions} visibleOptions={5} value={orders?.[0]?.addresses?.Billing?.stateOrProvince}
                                                         onValueChange={(selectedValue) => {setStateOrProvince(selectedValue.value);}} />
                                                        <MDBInput wrapperClass='mb-4' id='form6Country8' value={country.toUpperCase()} label='Country *' />

                                                        {!isPricing && <MDBRow md="2" className="mb-2 d-inline-flex me-1">
                                                            <MDBValidationItem invalid feedback='invalid'>
                                                                <MDBDatepicker format='dd, dddd, mmmm, yyyy'  defaultValue={deliveryDate || orders?.[0]?.deliveryDate} disablePast onChange={(date) => { setDeliveryDate(date); validateFields(); }}  inputLabel='Select a delivery date' />

                                                            </MDBValidationItem>
                                                        </MDBRow>}

                                                        {((newAddresses.length === 0 && type !== 'Both') || (orders?.[0]?.addresses?.Shipping)) && <MDBBtn
                                                            className='mb-4 mt-4'
                                                            type="button"

                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                addNewAddress();
                                                            }}
                                                        >
                                                            Add Another Address for shipping ?
                                                        </MDBBtn>}

                                                        {newAddresses.length === 1 && newAddresses?.map((address, index) => (
                                                            <div key={index} className='rounded-5 bg-success p-2 text-dark bg-opacity-10 mb-2'>

                                                                <MDBBtn
                                                                    className='mb-4'
                                                                    type="button"
                                                                    onClick={() => removeAddress(index)}
                                                                >
                                                                    Remove this address
                                                                </MDBBtn>
                                                                <MDBRow className='mb-4'>
                                                                    <MDBCol>
                                                                        <MDBInput label='First name *' id='formFirstName1new' value={address.firstName} onChange={(e) => updateField(index, 'firstName', e.target.value)} />
                                                                    </MDBCol>
                                                                    <MDBCol>
                                                                        <MDBInput label='Last name *' id='formLastName1new' value={address.lastName} onChange={(e) => updateField(index, 'lastName', e.target.value)} />
                                                                    </MDBCol>
                                                                </MDBRow>
                                                                <MDBSelect label='Billing and Shipping? *'
                                                                    className='mb-4'
                                                                    data={[
                                                                        { text: 'Shipping', disabled: type === 'Shipping' },
                                                                        { text: 'Billing', disabled: type === 'Billing' },

                                                                    ]}
                                                                    onValueChange={(selectedValue) => updateField(index, 'type', selectedValue.text)}
                                                                />
                                                                <MDBInput wrapperClass='mb-4' label="Street *" value={address.street} onChange={(e) => updateField(index, 'street', e.target.value)} />
                                                                <MDBInput wrapperClass='mb-4' label="City *" value={address.locality} onChange={(e) => updateField(index, 'locality', e.target.value)} />
                                                                <MDBInput wrapperClass='mb-4' label="PostalCode *" value={address.postalCode} onChange={(e) => updateField(index, 'postalCode', e.target.value)} />
                                                                <MDBSelect
                                                                    name='newStateOrProvince'
                                                                    label='State or Province *'
                                                                    id='stateOrProvinceSelectNew'
                                                                    type='text'
                                                                    search
                                                                    preventFirstSelection
                                                                    className='mb-4'
                                                                    data={stateOptions}
                                                                    visibleOptions={5}
                                                                    value={newAddresses[index].stateOrProvince} // use stateOrProvince value for the current address in the loop
                                                                    onValueChange={(selectedValue) => {
                                                                        updateField(index, 'stateOrProvince', selectedValue.value); // use updateField to update stateOrProvince
                                                                    }}
                                                                />
                                                                <MDBInput wrapperClass='mb-4 text-uppercase' label="Country *" value={country.toUpperCase()} />

                                                            </div>
                                                        ))}

                                                        <div className='rounded-5 bg-dark p-2 text-dark bg-opacity-10 '>
                                                            <MDBInput wrapperClass='mb-4' id='emailInCheckout' value={email} type='email' label='Email *' onChange={e => setEmail(e.target.value)} />
                                                            <MDBInput wrapperClass='mb-4' id='phoneInCheckout' value={phone} type='tel' label='Phone *' onChange={e => setPhone(e.target.value)} />
                                                            {(password.trim() !== confirmPassword.trim()) && <PasswordAlertCard/>}
                                                            {createAccount && <div className='rounded-5 bg-dark p-1 text-dark bg-opacity-10'>
                                                                <MDBInput className="mb-4" type="password"  id="registerPasswordInCheckout"    label="Password *"   value={password}    required  autoComplete="new-password"  onChange={e => { setPassword(e.target.value) }}/>
                                                                <MDBInput     className="mb-4"  type="password" id="confirmPassword"   label="Confirm password *"   value={confirmPassword}  required   autoComplete="new-password" onChange={e => {setConfirmPassword(e.target.value)}}/>
                                                            </div>}

                                                            <MDBInput wrapperClass='mb-2 mt-2' textarea id='additionalInformation' rows={4} label='Additional information' />

                                                            <MDBCheckbox  wrapperClass='d-flex justify-content-center mb-2'  id='form6Example9'    label='Create an account?'   defaultChecked onChange={() => setCreateAccount(!createAccount)}/>
                                                        </div>


                                                    </MDBCardBody>

                                                }

                                            </MDBStepperStep>

                                            <MDBStepperStep headIcon=<MDBIcon fas icon="cash-register" /> headText='Payment' itemId={tokenLoaded ? 3 : 2}>

                                                <div className='rounded-5 bg-black p-2  bg-opacity-10'>
                                                    <MDBRow className='mb-2 justify-content-center'>
                                                        <MDBCol md="3" className="mb-2 position-relative d-inline-block">
                                                            <MDBValidationItem>
                                                                <MDBRadio name='radioGroup' id='radioNoLabel1' defaultChecked label='Credit Card' onChange={() => { setPaymentType('Credit Card'); validateFields(); }} />
                                                            </MDBValidationItem>
                                                        </MDBCol>
                                                        <MDBCol md="3" className="mb-2 position-relative d-inline-block">
                                                            <MDBValidationItem>
                                                                <MDBRadio name='radioGroup' id='radioNoLabel2' label='Debit Card' onChange={() => { setPaymentType('Debit Card'); validateFields(); }} />
                                                            </MDBValidationItem>
                                                        </MDBCol>
                                                    </MDBRow>

                                                    <MDBRow className='mb-2 justify-content-center'>
                                                        <MDBRow md="3" className="mb-2 position-relative d-inline-block">
                                                            <MDBValidationItem invalid feedback='invalid'>
                                                                <MDBInput
                                                                    wrapperClass='mb-2'
                                                                    value={nameOnCard}
                                                                    label={
                                                                        <>
                                                                            Name on the card <small className='text-muted'>(required)</small>
                                                                        </>
                                                                    }
                                                                    onChange={(e) => { setNameOnCard(e.target.value); validateFields(); }}
                                                                    required type='text'
                                                                />
                                                            </MDBValidationItem></MDBRow>
                                                        <MDBRow md="3" className="mb-2 gap-3 d-inline-block">

                                                            <MDBValidationItem invalid feedback='invalid'>
                                                                <MDBInput type='number'
                                                                    value={cardNumber}
                                                                    label={
                                                                        <>
                                                                            Credit Cart Number <small className='text-muted' >(required)</small>
                                                                        </>
                                                                    }
                                                                    onChange={(e) => { setCardNumber(e.target.value); validateFields(); }}
                                                                    required
                                                                />
                                                            </MDBValidationItem>
                                                        </MDBRow>

                                                    </MDBRow>
                                                    <MDBRow md="3" className="mb-2 position-relative d-inline-block gap-3">

                                                        <MDBCol className='d-flex'>
                                                            <MDBRow md="2" className="mb-2 d-inline-flex me-1">
                                                                <MDBValidationItem invalid feedback='invalid'>
                                                                    <MDBDatepicker format='yyyy-mm' disablePast onChange={(date) => { setExpirationDate(date); validateFields(); }} inputToggle inputLabel='Expiration Date (required)' />

                                                                </MDBValidationItem>
                                                            </MDBRow>
                                                            <MDBRow md="2" className="mb-2 d-inline-block gap-3">
                                                                <MDBValidationItem invalid feedback='invalid' >
                                                                    <MDBInput
                                                                        className='gap-3'
                                                                        type='number'
                                                                        value={cardCode}
                                                                        min={0}
                                                                        label={
                                                                            <>
                                                                                CVV <small className='text-muted'>(required)</small>
                                                                            </>
                                                                        }
                                                                        onChange={(e) => { setCardCode(e.target.value); validateFields(); }}
                                                                    />
                                                                </MDBValidationItem>
                                                            </MDBRow>
                                                        </MDBCol>

                                                        <MDBCol>
                                                            <MDBCheckbox
                                                                wrapperClass='d-flex justify-content-center mb-4 '
                                                                id='form6Example8'
                                                                label='Save for future purchases?'
                                                                defaultChecked
                                                                onChange={() => setSaveCreditCard(!saveCreditCard)}
                                                            />

                                                        </MDBCol>
                                                    </MDBRow>
                                                </div>


                                            </MDBStepperStep>
                                        </div>
                                    </MDBStepper>


                                </MDBRow>

                            </MDBCol>

                            <MDBCol lg="4" className="mb-4 mt-4">
                                <MDBAnimation
                                    infinite
                                    slower={true}
                                    tag='i'
                                    animation='zoom-in'
                                    style={{ color: 'black' }}
                                    className='fas fa-check'
                                    start='onLoad'
                                    duration={25500}
                                >{validationMsg}  </MDBAnimation>
                                <MDBBtn color="primary" size="lg" className="mb-2" block onClick={handleSubmit} disabled={!isFormValid}>

                                    Place your order
                                </MDBBtn>

                                <>
                                    {
                                        Object.entries(getCategoryGroups() || {}).map(([categoryName, items]) => (
                                            <div key={categoryName}>

                                                <MDBCardTitle className='text-center'>
                                                    <MDBBadge color='light' light>
                                                        <h6 style={{ color: 'red' }}>{categoryName}</h6>
                                                    </MDBBadge>
                                                    <MDBBadge color='danger' notification pill>
                                                        {items.length}
                                                    </MDBBadge>
                                                </MDBCardTitle>
                                                <MDBTable>
                                                    <MDBTableBody>
                                                        {items?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className='d-flex align-items-center flex-wrap'>
                                                                        <div className='ms-1'>
                                                                            <img src={item.thumbnails && item.thumbnails[0]} alt='' className=' img-fluid' style={{ width: '30px', height: '30px' }} />
                                                                        </div>
                                                                        <MDBBadge className='ms-1 text-truncate fs-6' pill color='warning' light>
                                                                            <span className="d-inline-block text-truncate" style={{ maxWidth: 150 }}>
                                                                                {item.name}
                                                                            </span>
                                                                        </MDBBadge>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className='d-flex align-items-center flex-wrap fs-6'>
                                                                        <MDBBadge className='ms-1' pill color='primary' light>
                                                                            ${item.totalPrice}
                                                                        </MDBBadge>
                                                                        {!pricingCategoryId && <MDBBadge className='ms-1' pill color='primary' light>
                                                                            {item.totalWeightInLbs}
                                                                        </MDBBadge>}
                                                                        <MDBBadge className='ms-1' pill color='none' light>
                                                                            <MDBBtn tag='a' color='none' onClick={() => removeCartItem(item)} style={{ color: '#dd4b39' }}>
                                                                                <MDBIcon far icon="trash-alt" size='sm' />
                                                                            </MDBBtn>
                                                                        </MDBBadge>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </MDBTableBody>
                                                </MDBTable>
                                            </div>
                                        ))
                                    }

                                    <MDBListGroup>
                                        {!pricingCategoryId && <> <MDBListGroupItem className='text-start'>
                                            <span className="min-width-label">Total Weight In Kgs:</span>
                                            <span className="fs-6 px-2 fw-bold">{cart?.totalWeightInKgs}</span>
                                        </MDBListGroupItem>

                                            <MDBListGroupItem className='text-start'>
                                                <span className="min-width-label">Total Weight In lbs:</span>
                                                <span className="fs-6 px-2 fw-bold">{cart?.totalWeightInLbs}</span>
                                            </MDBListGroupItem>
                                        </>}
                                        <MDBListGroupItem className='text-start'>
                                            <span className="min-width-label">Total Amount:</span>
                                            <span className="fs-6 px-2 fw-bold">${cart?.totalAmount}</span>
                                        </MDBListGroupItem>

                                        <MDBListGroupItem className='text-start'>
                                            <span className="min-width-label">Total Sales Tax:</span>
                                            <span className="fs-6 px-2 fw-bold">${cart?.totalSalesTax}</span>
                                        </MDBListGroupItem>

                                        <MDBListGroupItem className='text-start'>
                                            <span className="min-width-label">Grand Total:</span>
                                            <span className="fs-5 px-2 fw-bold">${cart?.grandTotal}</span>
                                        </MDBListGroupItem>

                                    </MDBListGroup>

                                </>



                            </MDBCol>


                        </MDBRow>

                    </MDBCol>
                </MDBRow>



                {isUser && <UserProfileModal  showUserProfileModal={isUser} setShowUserProfileModal={handleIsUserProfileModalOpenToggle} isCheckout={true} />}
                {isAddress && <AddressFormModal showAddressModal={isAddress} setShowAddressModal={handleIsAddressModalOpenToggle} isCheckout={true} />}
                {isEmail && <EmailFormModal showEmailModal={isEmail} setShowEmailModal={handleIsEmailModalOpenToggle} isCheckout={true} />}
                {isPhone && <PhoneFormModal showPhoneModal={isPhone} setShowPhoneModal={handleIsPhoneModalOpenToggle} isCheckout={true} />}

            </MDBContainer>


    );
}